// Libraries
import { observable } from "mobx";

// Core
import { ModelBase } from "Core/Models/ModelBase";

// Custom
import { DelcoteGSModel, DelcoteGSModelDTO } from "./DelcoteProductModels/DelcoteGS";

export class DelcoteProductsModel extends ModelBase<DelcoteProductsModel, DelcoteProductsModelDTO> {
    private delcoteGSModel: DelcoteGSModel;

    constructor() {
        super();

        this.delcoteGSModel = new DelcoteGSModel();

        this.products.push({ title: "Substrate Undefined", value: "id_delcotesubstrateundefined" });

        this.productSelection = this.products[0];
    }

    // #region Model Properties

    public get DelcoteGSModel(): DelcoteGSModel {
        return this.delcoteGSModel;
    }

    @observable
    public products = observable<any>([]);

    @observable
    public productSelection: any = undefined;

    // #endregion Model Properties

    public fromDto(model: DelcoteProductsModelDTO): void {
        throw new Error("Method not implemented.");
    }

    public toDto(): DelcoteProductsModelDTO {
        return {
            delcoteGS: this.productSelection.value === "id_delcotesubstrateundefined" ? this.DelcoteGSModel.toDto() : undefined,
        };
    }
}

export interface DelcoteProductsModelDTO {
    delcoteGS?: DelcoteGSModelDTO;
}
